import { render, staticRenderFns } from "./footer2.vue?vue&type=template&id=67872d5c&scoped=true"
import script from "./footer2.vue?vue&type=script&lang=js"
export * from "./footer2.vue?vue&type=script&lang=js"
import style0 from "./footer2.vue?vue&type=style&index=0&id=67872d5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67872d5c",
  null
  
)

export default component.exports